module.exports = __webpack_public_path__ + "static/img/1_4_2.11be8da3.jpg";